import React, { useContext, useMemo } from "react";
import { createGlobalStyle } from 'styled-components';
import { UserDetailsContext } from "../context/userDetails";
import { IdntfyStore } from "../vars";

function ConfigWrapper({children}) {
const {shopDomain} = useContext(UserDetailsContext)

	const styleConfig = useMemo(() => {
		switch (shopDomain) {
			case IdntfyStore:
				return {
                    brandColor:"#220B12",
					primary: "#F6F1EB",
					secondary: "#220B12",
					heading: "#000",
					base: "#1E1E1E",
					btn: "#220B12",
					btnText: "#fff",
                    btnSize: "22px",
                    btnFont:"'EB Garamond', sans-serif",
					headingSize: "22px",
                    headingWeight: "700",
					baseSize: "16px",
					headingFont: "'EB Garamond', sans-serif",
					baseFont: "'Inter', sans-serif"
                    
				};
			default:
				return {
                    brandColor:"#5932F3",
					primary: "#fff",
					secondary: "#D9D9D9",
					heading: "#e5e4e0",
					base: "#000",
					btn: "#F9FAFC",
					btnText: "#0F172A",
                    btnSize: "14px",
                    btnFont:"'Inter', sans-serif",
					headingSize: "32px",
                    headingWeight: "normal",
					baseSize: "16px",
					headingFont: "'SeriouslyNostalgic Fn', sans-serif",
					baseFont: "'Inter', sans-serif"
				};
		}
	}, [shopDomain]);

	const GlobalStyles = createGlobalStyle`
		html {
        	--color-brand: ${styleConfig.brandColor};
			--color-primary: ${styleConfig.primary};
			--color-secondary: ${styleConfig.secondary};
			--color-heading: ${styleConfig.heading};
			--color-base: ${styleConfig.base};
			--color-btn: ${styleConfig.btn};
			--color-btnText: ${styleConfig.btnText};
			--heading-size: ${styleConfig.headingSize};
            --heading-weight: ${styleConfig.headingWeight};
			--base-size: ${styleConfig.baseSize};
			--heading-font: ${styleConfig.headingFont};
			--base-font: ${styleConfig.baseFont};
            --btn-font:${styleConfig.btnFont};
            --btn-size:${styleConfig.btnSize};
            --btn-bg:${styleConfig.btn};
            --btn-textColor:${styleConfig.btnText};
            
		}
	`;

	return (
		<>
			<GlobalStyles />
			{children}
		</>
	);
}

export default ConfigWrapper;
